<div
  class="mui-color-picker__input"
  [muiPopover]="picker"
  muiPopoverTriggers="sticky"
  [muiPopoverPlacement]="['bottom', 'auto']"
  [disablePopover]="disabled"
  [animation]="false"
  [class.has-focus]="hasFocus"
  (shown)="hasFocus = true"
  (hidden)="hasFocus = false">
  <div class="mui-color-picker__color-indicator" [style.background-color]="color"></div>
</div>


<ng-template #picker>
  <chrome-picker [control]="colorPickerControl" class="mui-color-picker__picker"></chrome-picker>
</ng-template>

